import { Button, Form, Input, Toast } from "antd-mobile";
import React, { CSSProperties, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import bg from "./assets/bg.png";
import storageUtil from "../../utils/storageUtil";
import { getCurrentUser, login } from "./service";

const wx = require("weixin-js-sdk");

const LoginScreen: React.FC = React.memo(() => {
  let accountInputRef: any;
  let passwordInputRef: any;
  const navigation = useNavigate();

  useEffect(() => {
    window.addEventListener(
      "popstate",
      function (e) {
        wx.miniProgram.navigateBack();
      },
      false
    );
  }, []);

  const onFinish = async (values: { account: string; password: string }) => {
    try {
      if (!values.account) {
        Toast.show({
          content: "登录账号不能为空",
          afterClose: () => {},
        });
        accountInputRef.focus();
        return;
      } else if (!values.password) {
        Toast.show({
          content: "登录密码不能为空",
          afterClose: () => {},
        });
        passwordInputRef.focus();
        return;
      }
      const credential = await login(
        values.account,
        values.password,
        "password"
      );
      storageUtil.setItem("CREDENTIAL", credential);
      const user = await getCurrentUser();
      if (!user) {
        throw new Error("无效的Token");
      }
      storageUtil.setItem("CURRENT_USER", user);
      // 跳转到首页
      navigation("/workspace");
    } catch (error: any) {
      Toast.show({
        content: error.message,
        afterClose: () => {},
      });
    }
  };

  return (
    <div style={container}>
      <div style={content}>
        <div style={box}>
          <Form
            onFinish={onFinish}
            mode="card"
            footer={
              <Button
                block
                type="submit"
                color="primary"
                size="large"
                style={{ backgroundColor: "#90E055", borderColor: "#90E055" }}
              >
                登录
              </Button>
            }
          >
            <Form.Item
              name="account"
              label="账号"
              rules={[{ required: false }]}
            >
              <Input
                placeholder="请输入登录账号"
                clearable
                ref={(ref) => (accountInputRef = ref)}
              />
            </Form.Item>
            <Form.Item
              name="password"
              label="密码"
              rules={[{ required: false }]}
            >
              <Input
                placeholder="请输入登录密码"
                clearable
                type="password"
                ref={(ref) => (passwordInputRef = ref)}
              />
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
});

const container: CSSProperties = {
  display: "flex",
  height: "100vh",
  width: "100%",
  backgroundImage: "url(" + bg + ")",
  backgroundRepeat: "repeat-x",
  justifyContent: "center",
};

const content: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: 60,
  width: "100%",
};

const title: CSSProperties = {
  fontSize: 24,
  fontWeight: "bold",
  color: "#fff",
};

const box: CSSProperties = {
  marginTop: 40,
  width: "85%",
};

export default LoginScreen;
